import { useWorkspaceActions } from '@/hooks/useWorkspace';
import { api } from '@/lib/trpc/react';

export const useNewSummary = () => {
  const { updateChatbot } = useWorkspaceActions();
  const utils = api.useUtils();

  const { mutateAsync: getIndexedSummary } =
    api.documentMetadata.indexedSummary.useMutation();

  const updateSummary = async (chatbotId: string) => {
    const data = await getIndexedSummary(chatbotId);
    const summary = data?.summary;

    if (!summary) return;

    utils.documentMetadata.byId.setData(
      { chatbotId: chatbotId },
      (prev) => prev && { ...prev, summary },
    );

    updateChatbot(chatbotId, {
      summary: data?.summary,
    });
  };

  return { updateSummary };
};
